import { createAction } from 'redux-actions';

export const APP_TOAST_REMOVE = 'APP_TOAST_REMOVE';

export default createAction(APP_TOAST_REMOVE);
